import { apiFetch } from '../../lib/api';

export interface HelpdeskOperatorGrant {
  user_id: string;
  granted_scopes: string[];
  status: 'active' | 'disabled' | string;
  granted_by?: string;
  grant_reason?: string;
  created_at: number;
  updated_at: number;
}

export async function listHelpdeskOperators(limit = 200): Promise<HelpdeskOperatorGrant[]> {
  const result = await apiFetch<{ items?: HelpdeskOperatorGrant[] }>('/v3/admin/helpdesk/operators', {
    query: { limit },
  });
  return result.data.items ?? [];
}

// `password` is the caller's own password, re-verified server-side as step-up
// (common/15 §1.3). It is sent on this request only — never stored, never put
// in state that outlives the submit, never echoed back by the server.
export async function setHelpdeskOperator(input: {
  userId: string;
  scopes: string[];
  status: 'active' | 'disabled';
  reason: string;
  password: string;
}): Promise<HelpdeskOperatorGrant> {
  const result = await apiFetch<HelpdeskOperatorGrant>('/v3/admin/helpdesk/operators', {
    method: 'PUT',
    body: {
      user_id: input.userId,
      scopes: input.scopes,
      status: input.status,
      reason: input.reason,
      password: input.password,
    },
  });
  return result.data;
}
